/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Deafen_Members_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to deafen other members in voice channels, which means they won’t be able to speak or hear others." |
*
* @param {Leveling_Perm_Deafen_Members_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_deafen_members_hint = /** @type {((inputs?: Leveling_Perm_Deafen_Members_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Deafen_Members_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам отключать звук другим участникам в голосовых каналах: те не смогут ни говорить, ни слышать остальных.")
	return /** @type {LocalizedString} */ ("Allows members to deafen other members in voice channels, which means they won’t be able to speak or hear others.")
});